function initPromoBanner(section) {
  const sectionId = section.dataset.sectionId;
  const slider = section.querySelector(`.promo-slider-track-${sectionId}`);
  const slides = slider ? slider.querySelectorAll(`.promo-slide-${sectionId}`) : [];
  const prev = section.querySelector(`.promo-slider-prev-${sectionId}`);
  const next = section.querySelector(`.promo-slider-next-${sectionId}`);
  const dotsContainer = section.querySelector(`.promo-slider-dots-${sectionId}`);
  const dots = dotsContainer ? dotsContainer.querySelectorAll(`.promo-dot-${sectionId}`) : [];

  if (!slider || slides.length === 0) return;

  let current = 0;
  let autoplayInterval;

  // Setup slider layout
  slider.style.display = 'flex';
  slider.style.transition = 'transform 0.5s ease';
  slides.forEach(slide => slide.style.flex = '0 0 100%');

  // Show dots if more than 1 slide
  if (dotsContainer && slides.length > 1) {
    dotsContainer.style.display = 'none';
  }
  function updateSlider(index) {
    // loop bounds
    if (index < 0) index = slides.length - 1;
    if (index >= slides.length) index = 0;
    current = index;

    // move slider
    slider.style.transform = `translateX(-${index * 100}%)`;

    // Active slide handling
    slides.forEach(slide => slide.classList.remove('active'));
    if (slides[index]) slides[index].classList.add('active');

    // Dots

    dots.forEach(dot => dot.classList.remove('active'));
    if (dots[index]) dots[index].classList.add('active');

    // Menu sync (OUTSIDE slider)
    const menus = section.querySelectorAll('.promo-menu-wrapper');

    let activeMenu = null;

    menus.forEach(menu => menu.classList.remove('active'));

    if (menus[index]) {
      menus[index].classList.add('active');
      activeMenu = menus[index];
    }

    // Dynamic text color (ONLY active menu)
    const textColor = slides[index].dataset.textColor;

    if (activeMenu) {
      const menuLinks = activeMenu.querySelectorAll('.promo-menu > .menu-item > a');
      menuLinks.forEach(link => {
        link.style.color = textColor;
      });
    }
  }

  function nextSlide() { updateSlider(current + 1); }
  function prevSlide() { updateSlider(current - 1); }

  function startAutoplay() {
    stopAutoplay();
    autoplayInterval = setInterval(nextSlide, 4000);
  }

  function stopAutoplay() {
    if (autoplayInterval) clearInterval(autoplayInterval);
  }

  if (next) next.addEventListener('click', nextSlide);
  if (prev) prev.addEventListener('click', prevSlide);
  dots.forEach((dot, index) => dot.addEventListener('click', () => updateSlider(index)));
  section.addEventListener('mouseenter', stopAutoplay);
  section.addEventListener('mouseleave', startAutoplay);

  updateSlider(0);
  startAutoplay(); 
}

// Initialize modals for all sections
function initPromoBannerModals() {
  if (window.promoModalInitialized) return;
  window.promoModalInitialized = true;

  document.addEventListener('click', e => {
    const trigger = e.target.closest('.promo-details-trigger');
    if (trigger) {
      const modalId = trigger.dataset.modal;
      const modal = document.getElementById(modalId);
      if (modal) {
        modal.classList.add('active');
        document.body.style.overflow = 'hidden';
      }
      return;
    }

    const closeBtn = e.target.closest('.close-button');
    if (closeBtn) {
      const modal = closeBtn.closest('.promo-banner-modal');
      if (modal) {
        modal.classList.remove('active');
        document.body.style.overflow = '';
      }
      return;
    }

    if (e.target.classList.contains('promo-banner-modal')) {
      e.target.classList.remove('active');
      document.body.style.overflow = '';
    }
  });

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
      document.querySelectorAll('.promo-banner-modal.active').forEach(modal => modal.classList.remove('active'));
      document.body.style.overflow = '';
    }
  });

  // ================================
  // Mobile Menu & Sub-dropdown Handling
  // ================================
  document.addEventListener('click', function(e) {
    const link = e.target.closest('.promo-menu > li > a');
    if (!link) return;

    const parentLi = link.parentElement;
    const dropdown = parentLi.querySelector('.dropdown');
    const subDropdown = parentLi.querySelector('.sub-dropdown');

    // Only handle items with dropdowns/sub-dropdowns on mobile
    if (window.innerWidth <= 768 && (dropdown || subDropdown)) {
      e.preventDefault();

      // Close other open dropdowns at the same level
      document.querySelectorAll('.promo-menu > li.open').forEach(item => {
        if (item !== parentLi) {
          item.classList.remove('open');
        }
      });

      // Toggle main dropdown
      if (dropdown) parentLi.classList.toggle('open');

      // Toggle sub-dropdowns
      if (subDropdown) parentLi.classList.toggle('open');
    }
    // If no dropdown exists, the link behaves normally
  });
  
}

// Initialize all banners on page
function initAllPromoBanners() {
  document.querySelectorAll('.promo-banner-section').forEach(section => initPromoBanner(section));
}

document.addEventListener('DOMContentLoaded', () => {
  initAllPromoBanners();
  initPromoBannerModals();
});

document.addEventListener('shopify:section:load', e => {
  if (e.target.classList.contains('promo-banner-section')) {
    initPromoBanner(e.target);
  }
});